import { render, staticRenderFns } from "./MenuTypeCard.vue?vue&type=template&id=e4dbd4f6&scoped=true"
import script from "./MenuTypeCard.vue?vue&type=script&lang=js"
export * from "./MenuTypeCard.vue?vue&type=script&lang=js"
import style0 from "./MenuTypeCard.vue?vue&type=style&index=0&id=e4dbd4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4dbd4f6",
  null
  
)

export default component.exports